export default {
  path: '/index',
  name: 'index',
  redirect: {
    name: 'memberCenter'
  },
  component: function component() {
    return import('@/layouts/basic-layout');
  },
  children: [// 采购商侧-协议管理-协议管理-协议维护
  {
    path: 'agrMintenanceList',
    name: 'agrMintenanceList',
    meta: {
      title: '协议维护',
      menuTab: '',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrMintenanceList']
    },
    component: function component() {
      return import('@/pages/agreementModule/unitAgrMenu/agrMintenanceList/agrMintenanceList.vue');
    }
  }, // 采购商侧-协议管理-协议管理-新增协议
  {
    path: 'agrMintenanceListForm',
    name: 'agrMintenanceListForm',
    meta: {
      title: '协议维护',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/agreementModule/unitAgrMenu/agrMintenanceList/agrMintenanceListForm.vue');
    }
  }, // 采购商侧-协议管理-协议管理-复制协议
  {
    path: 'agrMintenanceCopy',
    name: 'agrMintenanceCopy',
    meta: {
      title: '协议维护',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/agreementModule/unitAgrMenu/agrMintenanceList/agrMintenanceCopy.vue');
    }
  }, // 采购商侧-协议管理-协议管理-修改协议
  {
    path: 'agrMintenanceEdit',
    name: 'agrMintenanceEdit',
    meta: {
      title: '协议维护',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/agreementModule/unitAgrMenu/agrMintenanceList/agrMintenanceEdit.vue');
    }
  }, // 采购商侧-协议管理-协议管理-协议及协议版本详情
  {
    path: 'agrMintenanceDetail',
    name: 'agrMintenanceDetail',
    meta: {
      title: '协议维护',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/agreementModule/unitAgrMenu/agrMintenanceList/agrMintenanceDetail.vue');
    }
  }, // 采购商侧-协议管理-协议管理-协议详情
  {
    path: 'agrMintenanceOnly',
    name: 'agrMintenanceOnly',
    meta: {
      title: '协议维护',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/agreementModule/unitAgrMenu/agrMintenanceList/agrMintenanceOnly.vue');
    }
  }, // 采购商侧-协议管理-协议管理-协议版本协议详情
  {
    path: 'agrMintenanceVersionDetail',
    name: 'agrMintenanceVersionDetail',
    meta: {
      title: '协议维护',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/agreementModule/unitAgrMenu/agrMintenanceList/agrMintenanceVersionDetail.vue');
    }
  }, // 采购商侧-协议管理-协议管理-协议明细列表
  {
    path: 'agrDetailsList',
    name: 'agrDetailsList',
    meta: {
      title: '协议明细列表',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/agreementModule/unitAgrMenu/agrMintenanceList/agrDetailsList.vue');
    }
  }, // 采购商侧-协议管理-协议管理-已生效协议-查看商品清单
  {
    path: 'agrCommodityBoxList',
    name: 'agrCommodityBoxList',
    meta: {
      title: '协议维护',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/agreementModule/unitAgrMenu/agrMintenanceList/agrCommodityBoxList.vue');
    }
  }, // 采购商侧-协议管理-协议变更-协议变更列表
  {
    path: 'agrMintenanceChangeList',
    name: 'agrMintenanceChangeList',
    meta: {
      title: '协议变更',
      menuTab: '',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrMintenanceChangeList']
    },
    component: function component() {
      return import('@/pages/agreementModule/unitAgrMenu/agrMintenanceChangeList/agrMintenanceChangeList.vue');
    }
  }, // 采购商侧-协议管理-协议变更-协议变更新增列表
  {
    path: 'agrMintenanceChangeAddList',
    name: 'agrMintenanceChangeAddList',
    meta: {
      title: '发起协议变更',
      menuTab: '',
      cache: true,
      hidden: true
    },
    component: function component() {
      return import('@/pages/agreementModule/unitAgrMenu/agrMintenanceChangeList/agrMintenanceChangeAddList.vue');
    }
  }, // 采购商侧-协议管理-协议变更-协议变更新增
  {
    path: 'agrMintenanceChangeAdd',
    name: 'agrMintenanceChangeAdd',
    meta: {
      title: '协议变更',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/agreementModule/unitAgrMenu/agrMintenanceChangeList/agrMintenanceChangeAdd.vue');
    }
  }, // 采购商侧-协议管理-协议变更-修改
  {
    path: 'agrMintenanceChangeUpdate',
    name: 'agrMintenanceChangeUpdate',
    meta: {
      title: '协议变更修改',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/agreementModule/unitAgrMenu/agrMintenanceChangeList/agrMintenanceChangeUpdate.vue');
    }
  }, // 采购商侧-协议管理-协议变更-协议变更详情
  {
    path: 'agrMintenanceChangeDetails',
    name: 'agrMintenanceChangeDetails',
    meta: {
      title: '协议变更',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/agreementModule/unitAgrMenu/agrMintenanceChangeList/agrMintenanceChangeDetails.vue');
    }
  }, // 采购商侧-协议分配-列表
  {
    path: 'agrAllocationList',
    name: 'agrAllocationList',
    meta: {
      title: '协议分配',
      menuTab: '',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrAllocationList']
    },
    component: function component() {
      return import('@/pages/agreementModule/unitAgrMenu/agrAllocationList/agrAllocationList.vue');
    }
  }, // 采购商侧-协议分配-详情
  {
    path: 'agrAllocationDetails',
    name: 'agrAllocationDetails',
    meta: {
      title: '协议分配',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/agreementModule/unitAgrMenu/agrAllocationList/agrAllocationDetails.vue');
    }
  }, // 采购商侧-协议审批
  {
    path: 'agreementApprovalList',
    name: 'agreementApprovalList',
    meta: {
      title: '协议审批',
      menuTab: '',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agreementApprovalList']
    },
    component: function component() {
      return import('@/pages/agreementModule/agrApprovalMenu/agreementApprovalList/agreementApprovalList.vue');
    }
  }, // 采购商侧-协议审批-新增审批
  {
    path: 'agreementApprovalChangeAdd',
    name: 'agreementApprovalChangeAdd',
    meta: {
      title: '协议审批',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/agreementModule/agrApprovalMenu/agreementApprovalList/agreementApprovalChangeAdd.vue');
    }
  }, // 采购商侧-协议审批-审批详情
  {
    path: 'agreementApprovalDetails',
    name: 'agreementApprovalDetails',
    meta: {
      title: '协议审批',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/agreementModule/agrApprovalMenu/agreementApprovalList/agreementApprovalDetails.vue');
    }
  }, // 采购商侧-协议变更审批-列表
  {
    path: 'agrApprovalChangeList',
    name: 'agrApprovalChangeList',
    meta: {
      title: '协议变更审批',
      menuTab: '',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrApprovalChangeList']
    },
    component: function component() {
      return import('@/pages/agreementModule/agrApprovalMenu/agrApprovalChangeList/agrApprovalChangeList.vue');
    }
  }, // 采购商侧-协议下单-列表
  {
    path: 'agrByOrderList',
    name: 'agrByOrderList',
    meta: {
      title: '协议下单',
      menuTab: '',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrByOrderList']
    },
    component: function component() {
      return import('@/pages/agreementModule/agrPlaceOrderMenu/agrByOrderList/agrByOrderList.vue');
    }
  }, // 采购商侧-协议下单-选择商品
  {
    path: 'agrByOrderShop',
    name: 'agrByOrderShop',
    meta: {
      title: '协议下单',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/agreementModule/agrPlaceOrderMenu/agrByOrderList/agrByOrderShop.vue');
    }
  }, // 运营商
  // 运营商-协议管理-协议管理-协议维护
  {
    path: 'platAgrMintenanceList',
    name: 'platAgrMintenanceList',
    meta: {
      title: '平台协议维护',
      menuTab: '',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['platAgrMintenanceList']
    },
    component: function component() {
      return import('@/pages/agreementModule/platformAgrMenu/platAgrMintenanceList/platAgrMintenanceList.vue');
    }
  }, // 运营商-协议管理-协议管理-新增协议
  {
    path: 'platAgrMintenanceListForm',
    name: 'platAgrMintenanceListForm',
    meta: {
      title: '平台协议维护',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/agreementModule/platformAgrMenu/platAgrMintenanceList/platAgrMintenanceListForm.vue');
    }
  }, // 运营商-协议管理-协议管理-复制协议
  {
    path: 'platAgrMintenanceCopy',
    name: 'platAgrMintenanceCopy',
    meta: {
      title: '平台协议维护',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/agreementModule/platformAgrMenu/platAgrMintenanceList/platAgrMintenanceCopy.vue');
    }
  }, // 运营商-协议管理-协议管理-修改协议
  {
    path: 'platAgrMintenanceEdit',
    name: 'platAgrMintenanceEdit',
    meta: {
      title: '平台协议维护',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/agreementModule/platformAgrMenu/platAgrMintenanceList/platAgrMintenanceEdit.vue');
    }
  }, // 运营商-协议管理-协议管理-协议及协议版本详情
  {
    path: 'platAgrMintenanceDetail',
    name: 'platAgrMintenanceDetail',
    meta: {
      title: '平台协议维护',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/agreementModule/platformAgrMenu/platAgrMintenanceList/platAgrMintenanceDetail.vue');
    }
  }, // 运营商-协议管理-协议管理-协议详情
  {
    path: 'platAgrMintenanceOnly',
    name: 'platAgrMintenanceOnly',
    meta: {
      title: '平台协议维护',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/agreementModule/platformAgrMenu/platAgrMintenanceList/platAgrMintenanceOnly.vue');
    }
  }, // 运营商-协议管理-协议管理-协议明细列表
  {
    path: 'platAgrDetailsList',
    name: 'platAgrDetailsList',
    meta: {
      title: '平台协议维护明细列表',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/agreementModule/platformAgrMenu/platAgrMintenanceList/platAgrDetailsList.vue');
    }
  }, // 运营商-协议管理-协议管理-已生效协议-查看商品清单
  {
    path: 'platAgrCommodityBoxList',
    name: 'platAgrCommodityBoxList',
    meta: {
      title: '平台协议维护',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/agreementModule/platformAgrMenu/platAgrMintenanceList/platAgrCommodityBoxList.vue');
    }
  }, // 运营商-协议管理-协议变更-协议变更列表
  {
    path: 'platAgrMintenanceChangeList',
    name: 'platAgrMintenanceChangeList',
    meta: {
      title: '平台协议变更',
      menuTab: '',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['platAgrMintenanceChangeList']
    },
    component: function component() {
      return import('@/pages/agreementModule/platformAgrMenu/platAgrMintenanceChangeList/platAgrMintenanceChangeList.vue');
    }
  }, // 运营商-协议管理-协议变更-协议变更新增列表
  {
    path: 'platAgrMintenanceChangeAddList',
    name: 'platAgrMintenanceChangeAddList',
    meta: {
      title: '发起协议变更',
      menuTab: '',
      hidden: true,
      cache: true
    },
    component: function component() {
      return import('@/pages/agreementModule/platformAgrMenu/platAgrMintenanceChangeList/platAgrMintenanceChangeAddList.vue');
    }
  }, // 运营商-协议管理-协议变更-协议变更新增
  {
    path: 'platAgrMintenanceChangeAdd',
    name: 'platAgrMintenanceChangeAdd',
    meta: {
      title: '平台协议变更',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/agreementModule/platformAgrMenu/platAgrMintenanceChangeList/platAgrMintenanceChangeAdd.vue');
    }
  }, // 运营商-协议管理-协议变更-协议变更新增
  {
    path: 'platAgrMintenanceChangeUpdate',
    name: 'platAgrMintenanceChangeUpdate',
    meta: {
      title: '平台协议变更',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/agreementModule/platformAgrMenu/platAgrMintenanceChangeList/platAgrMintenanceChangeUpdate.vue');
    }
  }, // 运营商-协议管理-协议变更-协议变更详情
  {
    path: 'platAgrMintenanceChangeDetails',
    name: 'platAgrMintenanceChangeDetails',
    meta: {
      title: '平台协议变更',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/agreementModule/platformAgrMenu/platAgrMintenanceChangeList/platAgrMintenanceChangeDetails.vue');
    }
  }, // 运营商-协议分配-列表
  {
    path: 'platAgrAllocationList',
    name: 'platAgrAllocationList',
    meta: {
      title: '平台协议协议分配',
      menuTab: '',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['platAgrAllocationList']
    },
    component: function component() {
      return import('@/pages/agreementModule/platformAgrMenu/platAgrAllocationList/platAgrAllocationList.vue');
    }
  }, // 运营商-协议分配-详情
  {
    path: 'platAgrAllocationDetails',
    name: 'platAgrAllocationDetails',
    meta: {
      title: '平台协议协议分配',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/agreementModule/platformAgrMenu/platAgrAllocationList/platAgrAllocationDetails.vue');
    }
  }, // 供应商侧-协议确认-列表
  {
    path: 'agrConfirmationList',
    name: 'agrConfirmationList',
    meta: {
      title: '协议确认',
      menuTab: '',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['agrConfirmationList']
    },
    component: function component() {
      return import('@/pages/agreementModule/agrMenu/agrConfirmationList/agrConfirmationList.vue');
    }
  }, // 供应商侧-协议确认-确认页面
  {
    path: 'agrConfirmationListAdd',
    name: 'agrConfirmationListAdd',
    meta: {
      title: '协议确认',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/agreementModule/agrMenu/agrConfirmationList/agrConfirmationListAdd.vue');
    }
  }, // 供应商侧-协议确认-详情页面
  {
    path: 'agrConfirmationDetails',
    name: 'agrConfirmationDetails',
    meta: {
      title: '协议确认',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/agreementModule/agrMenu/agrConfirmationList/agrConfirmationDetails.vue');
    }
  }, // 供应商-协议管理-查看商品清单
  {
    path: 'agrConfirmationBoxList',
    name: 'agrConfirmationBoxList',
    meta: {
      title: '商品清单',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/agreementModule/agrMenu/agrConfirmationList/agrConfirmationBoxList.vue');
    }
  }]
};